var sourceFile = require('../../../config/config.js');
const rootDir = sourceFile.rootDir;
var swv = 'sw-visibility';
var impt = 'code-import';
var osm = 'open-sm';
var otm = 'open-tm';
var ola = 'open-layers';
var obl = 'open-blocks';
var ful = 'fullscreen';
var prv = 'preview';
var compexp = 'studio-export';
var sidebar = 'show-sidebar';
var addcomp = 'add-new-control';
var edit = 'edit-control';
var save = 'save-control';
var openMenu = 'open-menu';
var cgdev = 'change-device';
export default {
  stylePrefix: 'pn-',

  // Default panels fa-sliders for features
  defaults: [
    {
      id: 'logo',
      buttons: [
        {
          active: false,
          togglable: false,
          id: 'studio',
          className: 'logo',
          command: 'logoclicked',
          markup: `<img src="${rootDir}/assets/icons/studiologo.svg"><i class="fa fa-arrow-left"></i><span class="title">Studio</span>`,
          attributes: { title: '' }
        }
      ]
    },
    {
      id: 'controlName',
      buttons: [
        {
          id: edit,
          className: 'fa fa-pencil font14',
          command: edit,
          markup: '<span class="title">Edit component meta</span>',
          attributes: { title: '' }
        },
        {
          id: sidebar,
          className: 'fa fa-chevron-down font14',
          command: sidebar,
          markup: '<span class="title">Controls</span>',
          attributes: { title: '' }
        }
      ]
    },
    {
      id: 'devices-c',
      buttons: [
        {
          id: 'Desktop',
          className: 'fa fa-laptop font25',
          command: cgdev,
          togglable: 0,
          active: true,
          markup: `<span class="title">Desktop</span>`,
          attributes: { title: '' }
        },
        {
          id: 'Tablet',
          className: 'fa fa-tablet font25',
          command: cgdev,
          togglable: 0,
          markup: `<span class="title">Tablet</span>`,
          attributes: { title: '' }
        },
        {
          id: 'Mobile landscape',
          className: 'fa fa-tablet fa-rotate-270 font25',
          command: cgdev,
          togglable: 0,
          markup: `<span class="title" style="transform: rotate(90deg) translate(-50px, 45px);">Mobile landscape</span>`,
          attributes: { title: '' }
        },
        {
          id: 'Mobile portrait',
          className: 'fa fa-mobile font25',
          command: cgdev,
          togglable: 0,
          markup: `<span class="title">Mobile portrait</span>`,
          attributes: { title: '' }
        }
      ]
    },
    {
      id: 'options',
      buttons: [
        {
          id: impt,
          className: 'fa fa-code',
          command: impt,
          markup: '<span class="title">Edit Code</span>',
          attributes: {
            title: ''
          }
        },
        {
          id: addcomp,
          className: 'fa fa-plus',
          command: addcomp,
          markup: '<span class="title">Add New components</span>',
          attributes: { title: '' }
        },
        {
          id: save,
          className: 'fa fa-save',
          command: save,
          markup: '<span class="title">Save components</span>',
          attributes: { title: '' }
        },
        {
          id: compexp,
          className: 'fa fa-cloud-upload',
          command: compexp,
          markup: '<span class="title">Publish Component</span>',
          attributes: {
            title: ''
          }
        }
      ]
    },
    {
      id: 'views',
      buttons: [
        {
          id: osm,
          className: '',
          command: osm,
          active: true,
          togglable: 0,
          markup: `<img class="hide" activateurl src="${rootDir}/assets/icons/activestylemanager.svg"><img deactivateurl src="${rootDir}/assets/icons/stylemanager.svg"><span class="title">Style Manager</span>`,
          attributes: { title: '' }
        },
        {
          id: otm,
          className: '',
          command: otm,
          togglable: 0,
          markup: `<img class="hide" activateurl src="${rootDir}/assets/icons/activetraits.svg"><img deactivateurl src="${rootDir}/assets/icons/traits.svg"><span class="title">Mappings Manager</span>`,
          attributes: { title: '' }
        },
        {
          id: ola,
          className: '',
          command: ola,
          togglable: 0,
          markup: `<img class="hide" activateurl src="${rootDir}/assets/icons/activelayers.svg"><img deactivateurl src="${rootDir}/assets/icons/layers.svg"><span class="title">Layers Manager</span>`,
          attributes: { title: '' }
        },
        {
          id: obl,
          className: '',
          command: obl,
          active: false,
          togglable: 0,
          markup: `<img class="hide" activateurl src="${rootDir}/assets/icons/activeblocks.svg"><img deactivateurl src="${rootDir}/assets/icons/blocks.svg"><span class="title">Blocks</span>`,
          attributes: { title: '' }
        }
      ]
    },
    {
      id: 'left-top-view',
      buttons: [
        // {
        //   id: sidebar,
        //   command: sidebar,
        //   togglable: 1,
        //   className: 'viewControls',
        //   markup: `<img class="hide" activateurl src="${rootDir}/assets/icons/activecontrollist.svg"><img deactivateurl src="${rootDir}/assets/icons/controllist.svg"><span class="title right">Controls</span>`,
        //   attributes: { title: 'View Controls' }
        // },
        // {
        //   id: 'market_place_menu',
        //   command: openMenu,
        //   togglable: 1,
        //   markup: `<img class="hide" activateurl src="${rootDir}/assets/icons/activemarketplace.svg"><img deactivateurl src="${rootDir}/assets/icons/marketplace.svg"><span class="title right">Marketplace</span>`,
        //   className: 'Marketplace',
        //   attributes: { title: 'View Marketplace' }
        // }
      ]
    },
    {
      id: 'left-bottom-view',
      buttons: [
        {
          active: true,
          id: swv,
          className: 'fa fa-square-o',
          command: swv,
          context: swv,
          markup: '<span class="title right">View lines</span>',
          attributes: { title: '' }
        },
        {
          id: prv,
          className: 'fa fa-eye',
          command: prv,
          context: prv,
          markup: '<span class="title right">Preview</span>',
          attributes: { title: '' }
        },
        {
          id: ful,
          className: 'fa fa-arrows-alt',
          command: ful,
          context: ful,
          markup: '<span class="title right">Fullscreen</span>',
          attributes: { title: '' }
        }
      ]
    }
  ],

  // Editor model
  em: null,

  // Delay before show children buttons (in milliseconds)
  delayBtnsShow: 300
};
